import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.replace";
import _flatMap from "lodash/flatMap";
import _head from "lodash/head";
import _trim from "lodash/trim";
import _uniqueid from "lodash/uniqueId";
import _omit from "lodash/omit";
import _isEqual from "lodash/isEqual";
import _includes from "lodash/includes";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';
import defined from 'defined';
import { CheckboxInline } from '@nerdwallet/react-checkbox';
import { RadioInline } from '@nerdwallet/react-radio';
import Link from '@nerdwallet/react-link';
import styles from './dropdown-select.module.less';
import NativeSelect from '../native-select';
import { SELECT_PROP_TYPES, SELECT_DEFAULT_PROPS } from '../prop-types';
import expandable from './expandable';
import DropdownTrigger from '../dropdown-trigger';

var dasherize = function dasherize(str) {
  return _trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
};

var getOptionId = function getOptionId(option, id, name) {
  return dasherize("".concat(name, "--").concat(option.label, "-").concat(option.value || option.label, "--").concat(id));
};

var flattenOptions = function flattenOptions(options) {
  if (!options || options.length === 0) {
    return null;
  } // There are 2 formats for options.


  var exampleOptions = _head(options);

  var nestedOptions = exampleOptions.options;

  if (nestedOptions) {
    return _flatMap(options, function (option) {
      return option.options;
    });
  }

  return options;
};

var getLabelFromOptions = function getLabelFromOptions(options, value) {
  // Extract label from option if only one is selected
  var label;
  var flattenedOptions = flattenOptions(options) || [];
  flattenedOptions.forEach(function (option) {
    var optionLabel = option.label,
        optionValue = option.value;

    if (optionValue === value) {
      label = optionLabel;
    }
  });
  return label;
};

var getSummaryText = function getSummaryText(options, value, prompt) {
  switch (Array.isArray(value) && value.length) {
    case false:
      return value || prompt;

    case 0:
      return prompt;

    case 1:
      return getLabelFromOptions(options, value[0]) || value[0];

    default:
      return "".concat(value.length, " selected");
  }
};

var propTypes = {
  block: bool
};
var defaultProps = {};
/**
 * Provides a popover-style select UI. Naturally appears
 * as a native select, but when activated, lists options
 * as checkbox or radio lists.
 *
 * Used by `Select` when *both* of the following are true:
 * 1. User device is finely-pointed (e.g. mouse-driven)
 * 2. `popover` or `multiple` is true
 */

var DropdownSelect =
/*#__PURE__*/
function (_Component) {
  _inherits(DropdownSelect, _Component);

  function DropdownSelect(props) {
    var _this;

    _classCallCheck(this, DropdownSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownSelect).call(this, props));
    var id = props.id,
        name = props.name; // ensure the instance has an id and name to prevent unexpected option selection behavior

    _this.id = id || _uniqueid();
    _this.name = name || _uniqueid();
    return _this;
  }
  /**
   * shapes select option to checkbox/radio props
   * @param  {object} options Select options
   * @return {object}         Checkbox/Radio options
   */


  _createClass(DropdownSelect, [{
    key: "ensureInputOption",
    value: function ensureInputOption() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props = this.props,
          multiple = _this$props.multiple,
          selected = _this$props.value;
      var options = option.options,
          label = option.label,
          value = option.value;
      var isChecked = multiple ? _includes : _isEqual; // for safety, ignore if this is an optgroup

      if (options) {
        return option;
      }

      return _objectSpread({}, option, {
        label: label,
        value: defined(value, label),
        checked: isChecked(selected, defined(value, label))
      });
    }
  }, {
    key: "renderOptGroup",
    value: function renderOptGroup(optgroup) {
      var id = this.id;
      var title = optgroup.title,
          options = optgroup.options;
      var optgroupId = "".concat(id, "__optgroup--").concat(dasherize(title));
      return React.createElement("li", {
        className: styles.optgroup,
        key: optgroupId
      }, React.createElement("p", {
        id: optgroupId,
        className: styles.title
      }, title), this.renderOptions(options, optgroupId));
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var _this$props2 = this.props,
          multiple = _this$props2.multiple,
          onChange = _this$props2.onChange;
      var name = this.name,
          id = this.id;
      var Input = multiple ? CheckboxInline : RadioInline;
      var inputOption = this.ensureInputOption(option);
      var label = inputOption.label,
          value = inputOption.value;
      return React.createElement("li", {
        className: styles.option,
        key: "option__".concat(label, "__").concat(value)
      }, React.createElement(Input, _extends({}, inputOption, {
        label: React.createElement("span", {
          className: styles.label
        }, label),
        className: styles.input,
        name: name,
        id: getOptionId(inputOption, name, id),
        "aria-controls": id,
        onChange: onChange
      })));
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(options, labelledBy) {
      var _this2 = this;

      var items = options.map(function (o) {
        return o.options ? _this2.renderOptGroup(o) : _this2.renderOption(o);
      });
      return React.createElement("ul", {
        className: styles.options,
        "aria-labelledby": labelledBy
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props3 = this.props,
          block = _this$props3.block,
          className = _this$props3.className,
          options = _this$props3.options,
          error = _this$props3.error,
          disabled = _this$props3.disabled,
          unselected = _this$props3.unselected,
          expandableContainerProps = _this$props3.expandableContainerProps,
          expandableToggleProps = _this$props3.expandableToggleProps,
          value = _this$props3.value;
      var id = this.id; // this NativeSelect is rendered to size (shim) the content of the
      // container to what a native select would (largest selectable value).
      // it is visually and a11y hidden and the DropdownSelect is rendered over.
      // This allows the DropdownSelect summary to stretch to fit the same size
      // as a native select would.

      var shimProps = _objectSpread({}, _omit(this.props, ['block', 'popover', 'value', 'defaultValue'].concat(_toConsumableArray(Object.keys(expandable.propTypes)))), {
        className: classNames(className, styles.shim),
        // id should go on summary instead since this is hidden
        id: undefined,
        // we want it to render as a single line
        multiple: false,
        // assistive tech shouldn't see this
        'aria-hidden': true,
        disabled: true
      });

      var shim = React.createElement(NativeSelect, shimProps);
      var containerClasses = classNames(styles.container, (_classNames = {}, _defineProperty(_classNames, styles.inline, !block), _defineProperty(_classNames, styles.block, block), _classNames));
      return React.createElement("div", {
        className: containerClasses
      }, React.createElement("div", {
        className: styles.trigger
      }, shim, React.createElement("div", {
        className: styles.facade
      }, React.createElement(DropdownTrigger, _extends({}, expandableToggleProps, {
        block: true,
        mode: "button",
        error: error,
        disabled: disabled
      }), getSummaryText(options, value, unselected === null ? 'Choose…' : unselected)))), React.createElement("section", expandableContainerProps, React.createElement("div", {
        className: styles.choices
      }, this.renderOptions(options, id)), React.createElement("footer", {
        className: styles.footer
      }, React.createElement(Link, _extends({}, expandableToggleProps, {
        decorated: true,
        color: "neutral-darker",
        className: classNames(styles.action, expandableToggleProps.className)
      }), "Done"))));
    }
  }]);

  return DropdownSelect;
}(Component);

DropdownSelect.displayName = 'DropdownSelect';
DropdownSelect.propTypes = _objectSpread({}, propTypes, SELECT_PROP_TYPES, expandable.propTypes);
DropdownSelect.defaultProps = _objectSpread({}, defaultProps, SELECT_DEFAULT_PROPS, expandable.defaultProps);
export default expandable(DropdownSelect, 'popover');